export default __webpack_public_path__ + "static/media/logomr.4f2df92d.png";